import { IPathToPageIdMap } from '@move-frontend/contentful-routes';
import { ILinkEntry } from '../../../../contentful/types/ILinkEntry';
import { getLinkItemForEntry } from './getLinkItemForEntry';
import {
	IAssetLinkItem,
	IEmailLinkItem,
	IExternalLinkItem,
	IInternalLinkItem,
	IPhoneLinkItem,
} from '../../../../ui';

type ILinkItem =
	| IAssetLinkItem
	| IEmailLinkItem
	| IExternalLinkItem
	| IInternalLinkItem
	| IPhoneLinkItem;

export function getLinkItemsForEntries<T extends ILinkItem>(
	entries: ILinkEntry[],
	pathToPageIdMap: IPathToPageIdMap,
) {
	if (!entries || !entries.length) {
		return [];
	}
	return entries
		.map((entry, index) => {
			const item = getLinkItemForEntry(entry, index, pathToPageIdMap);
			return item as T;
		})
		.filter(Boolean);
}
